// extracted by mini-css-extract-plugin
module.exports = {"bodyContainer":"DefaultBodyContainer_bodyContainer__2Tn-q","paddingContainer":"DefaultBodyContainer_paddingContainer__3p6jW"};